import React, { useState } from 'react';

function PersonalInfoStep({ data, updateData, nextStep }) {
  const [errors, setErrors] = useState({});

  const handleInputChange = (field, value) => {
    updateData({ [field]: value });
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: null }));
    }
  };

  const validateAndNext = () => {
    const newErrors = {};
    
    if (!data.firstName.trim()) {
      newErrors.firstName = 'First name is required';
    }
    
    if (!data.lastName.trim()) {
      newErrors.lastName = 'Last name is required';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    nextStep();
  };

  return (
    <div className="bg-white bg-opacity-5 rounded-lg border border-gray-200 border-opacity-20 p-8 md:p-12">
      {/* Header */}
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-white mb-3">
          Let's start with your <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">name</span>
        </h2>
        <p className="text-gray-400">
          We'll use this to personalize your Elena experience
        </p>
      </div>

      {/* Form */}
      <div className="max-w-md mx-auto space-y-6">
        {/* First Name */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            First Name *
          </label>
          <input
            type="text"
            value={data.firstName}
            onChange={(e) => handleInputChange('firstName', e.target.value)}
            className={`w-full bg-white bg-opacity-10 border rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:bg-opacity-15 transition-all duration-200 ${
              errors.firstName 
                ? 'border-red-500 focus:border-red-400' 
                : 'border-gray-200 border-opacity-20 focus:border-blue-500'
            }`}
            placeholder="Enter your first name"
            autoFocus
          />
          {errors.firstName && (
            <p className="text-red-400 text-sm mt-1">{errors.firstName}</p>
          )}
        </div>

        {/* Last Name */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Last Name *
          </label>
          <input
            type="text"
            value={data.lastName}
            onChange={(e) => handleInputChange('lastName', e.target.value)}
            className={`w-full bg-white bg-opacity-10 border rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:outline-none focus:bg-opacity-15 transition-all duration-200 ${
              errors.lastName 
                ? 'border-red-500 focus:border-red-400' 
                : 'border-gray-200 border-opacity-20 focus:border-blue-500'
            }`}
            placeholder="Enter your last name"
          />
          {errors.lastName && (
            <p className="text-red-400 text-sm mt-1">{errors.lastName}</p>
          )}
        </div>

        {/* Continue Button */}
        <div className="pt-4">
          <button
            onClick={validateAndNext}
            className="w-full px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-medium rounded-lg hover:from-blue-600 hover:to-purple-600 transition-all duration-200"
          >
            Continue
          </button>
        </div>
      </div>

      {/* Help Text */}
      <div className="text-center mt-8">
        <p className="text-gray-500 text-sm">
          This information helps us create a personalized profile for you
        </p>
      </div>
    </div>
  );
}

export default PersonalInfoStep; 